import request from './request'

function unwrap (res) {
  return res?.data ?? res
}

function normalizeMeta (meta = {}) {
  return {
    currentPage: Number(meta.currentPage ?? meta.current_page ?? 1),
    perPage: Number(meta.perPage ?? meta.per_page ?? 10),
    total: Number(meta.total ?? 0),
    lastPage: Number(meta.lastPage ?? meta.last_page ?? 1)
  }
}

export const getActivitySmsSettings = (activityId) =>
  request.get(`/activities/${activityId}/sms-settings`).then(unwrap)

export const updateActivitySmsSettings = (activityId, data) =>
  request.put(`/activities/${activityId}/sms-settings`, data).then(unwrap)

export const listActivitySmsTemplates = (activityId) =>
  request.get(`/activities/${activityId}/sms-settings/templates`).then((res) => res?.data || [])

export const updateActivitySmsTemplate = (activityId, templateKey, data) =>
  request.put(`/activities/${activityId}/sms-settings/templates/${templateKey}`, data).then(unwrap)

export const listActivitySmsRecipients = (activityId, params = {}) =>
  request.get(`/activities/${activityId}/sms-recipients`, { params }).then((res) => ({
    items: Array.isArray(res?.data) ? res.data : [],
    meta: normalizeMeta(res?.meta)
  }))

export const createActivitySmsBatch = (activityId, data) =>
  request.post(`/activities/${activityId}/sms-send-batches`, data, {
    suppress422Toast: true
  }).then(unwrap)

export const getActivitySmsBatch = (activityId, batchId) =>
  request.get(`/activities/${activityId}/sms-send-batches/${batchId}`).then(unwrap)

export const listActivitySmsRecords = (activityId, params = {}) =>
  request.get(`/activities/${activityId}/sms-records`, { params }).then((res) => ({
    items: Array.isArray(res?.data) ? res.data : [],
    meta: normalizeMeta(res?.meta),
    summary: res?.summary || null
  }))

export const getActivitySmsRecord = (activityId, recordId) =>
  request.get(`/activities/${activityId}/sms-records/${recordId}`).then(unwrap)

export const resendActivitySmsRecord = (activityId, recordId, data = {}) =>
  request.post(`/activities/${activityId}/sms-records/${recordId}/resend`, data, {
    suppress422Toast: true
  }).then(unwrap)

export const queryActivitySmsRecordStatus = (activityId, recordId) =>
  request.post(`/activities/${activityId}/sms-records/${recordId}/query-status`).then(unwrap)
